import styled from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'

export const Notification = {
    Area: styled.div`
        ${FlexCentered}
        justify-content: space-evenly;
        padding: 15px;

        width: 97vw; // default mobile

        min-height: 50px;
        height: auto;

        background: #36383c;

        box-shadow: 0px 8px 24px rgba(17, 17, 26, 0.06),
            0px 12px 32px rgba(17, 17, 26, 0.06);
        border-radius: 8px;

        & > div {
            height: 100%;
            margin: 0px 2.5px;
        }

        // Tabs and up
        @media (min-width: 768px) {
            width: 50vw;
        }

        // Laptops and up
        @media (min-width: 992px) {
            width: 400px;
        }
    `,
    Icon: styled.div`
        flex-basis: 10%;
        ${FlexCentered}
        img {
            width: 30px;
        }
    `,
    Content: styled.div`
        display: flex;
        justify-content: center;
        flex-direction: column;
        flex-basis: 70%;
    `,
    Cta: styled.div`
        ${FlexCentered}
        div {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 4px 12px;

            width: 32px;
            height: 32px;

            background: rgba(0, 0, 8, 0.3);
            border-radius: 48px;
            opacity: 0.5;

            :hover {
                opacity: 1;
            }

            img {
                filter: brightness(0) invert(1);
            }
        }
    `,
}
